import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';

const RouteSelection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const popularRoutes = [
    {
      id: 1,
      from: 'Chandigarh',
      to: 'Haridwar',
      startingPrice: 3500
    },
    {
      id: 2,
      from: 'Chandigarh',
      to: 'Shimla',
      startingPrice: 2500
    },
    {
      id: 3,
      from: 'Delhi',
      to: 'Chandigarh',
      startingPrice: 3200
    },
    {
      id: 4,
      from: 'Chandigarh',
      to: 'Amritsar',
      startingPrice: 3200
    },
    {
      id: 5,
      from: 'Delhi Airport',
      to: 'Chandigarh',
      startingPrice: 3200
    },
    {
      id: 6,
      from: 'Chandigarh',
      to: 'Delhi Airport',
      startingPrice: 3200
    },
    {
      id: 7,
      from: 'Chandigarh',
      to: 'Delhi',
      startingPrice: 3200
    },
    {
      id: 8,
      from: 'Delhi',
      to: 'Kharar',
      startingPrice: 3500
    },
    {
      id: 9,
      from: 'Chandigarh',
      to: 'Noida',
      startingPrice: 3800
    },
    {
      id: 10,
      from: 'Delhi',
      to: 'Ludhiana',
      startingPrice: 4500
    },
    {
      id: 11,
      from: 'Chandigarh',
      to: 'Jammu',
      startingPrice: 4200
    },
    {
      id: 12,
      from: 'Chandigarh',
      to: 'Manali',
      startingPrice: 4500
    }
  ];

  const handleRouteClick = (route) => {
    navigate('/car-selection', {
      state: {
        route: route
      }
    });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      
      <main className="flex-1">
        <div className="bg-gradient-journey text-white py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-4">
              One Way Popular Routes
            </h1>
            <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto">
              Select your route and choose from our wide range of comfortable vehicles
            </p>
          </div>
        </div>

        <section className="py-12 md:py-16 lg:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {popularRoutes?.map((route) => (
                <div
                  key={route?.id}
                  onClick={() => handleRouteClick(route)}
                  className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300 cursor-pointer card-hover group"
                >
                  <div className="text-center space-y-4">
                    <h3 className="text-xl font-heading font-bold text-foreground group-hover:text-primary transition-colors">
                      {route?.from} To {route?.to}
                    </h3>
                    
                    <div className="flex items-center justify-center gap-2 text-muted-foreground">
                      <Icon name="MapPin" size={16} className="text-primary" />
                      <span className="text-sm">One Way Taxi Service</span>
                    </div>
                    
                    <div className="pt-4 border-t border-border">
                      <p className="text-sm text-muted-foreground mb-1">Fare Start -</p>
                      <p className="text-2xl font-bold text-primary">
                        ₹ {route?.startingPrice?.toLocaleString('en-IN')}/-
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default RouteSelection;